/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Constants } from '../../../Constants';
import { Server } from '../../../models/common/Server';
import { ValidationRuleMetaData } from '../../ValidationRuleMetaData';
import { RequiredPropertyValidationRule } from './RequiredPropertyValidationRule';

/**
 * @author cfoskin@redhat.com
 * @param {ValidationRuleMetaData} ruleInfo
 * @class
 * @extends RequiredPropertyValidationRule
 */
export class AasMissingServerProtocolRule extends RequiredPropertyValidationRule {
    public constructor(ruleInfo : ValidationRuleMetaData) {
        super(ruleInfo);
    }

    /**
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitServer(io.apicurio.datamodels.core.models.common.Server)
     * @param {Server} node
     */
    public visitServer(node : Server) {
        this.requireProperty(node, Constants.PROP_PROTOCOL, this.map.apply(this, ));
    }
}
AasMissingServerProtocolRule["__class"] = "io.apicurio.datamodels.core.validation.rules.required.AasMissingServerProtocolRule";
AasMissingServerProtocolRule["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




